import { render, staticRenderFns } from "./PendingCountBadge.vue?vue&type=template&id=0796401c&scoped=true"
import script from "./PendingCountBadge.vue?vue&type=script&lang=js"
export * from "./PendingCountBadge.vue?vue&type=script&lang=js"
import style0 from "./PendingCountBadge.vue?vue&type=style&index=0&id=0796401c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0796401c",
  null
  
)

export default component.exports